export const tabsNames = {
	basicInfo: 'basicInfo',
	details: 'details',
	dependencies: 'dependencies',
};

export const fieldsToTestBasicInfo = [
	'project',
	'title',
	'description',
];

export const fieldsToTestDetails = [
	'startDate',
	'endDate',
	'assignees',
];

export const milestoneFormFields = {
	project: 'project',
	title: 'title',
	description: 'description',
	startDate: 'startDate',
	endDate: 'endDate',
	assignees: 'assignees',
	status: 'status',
};

export const portalMilestoneStatuses = {
	active: 'ACTIVE',
	completed: 'COMPLETED',
};
